import { FormEngineModeTypeEnum } from '@celito.clients/enums';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CurriculumPreviewPageProps } from './curriculum-preview-page.model';
import { CurriculumPreviewPageView } from './curriculum-preview-page.view';

interface CurriculumPreviewPageControllerProps extends CurriculumPreviewPageProps {}

export const CurriculumPreviewPageController = (
  props: CurriculumPreviewPageControllerProps
): JSX.Element => {
  const { watch } = useFormContext() || {};

  let recordDetails = props.recordDetails;

  if (props.mode !== FormEngineModeTypeEnum.View) {
    const formValues = watch?.();

    recordDetails = {};
    props.attributeConfig.objectAttributeDefinitions?.forEach((item) => {
      recordDetails![item.columnName] = formValues?.[item.name];
    });
  }

  useEffect(() => {
    if (props.mode === FormEngineModeTypeEnum.View) {
      return;
    }

    props.setWizardStepsState((prev) =>
      prev.map((prevStep) =>
        prevStep.label === props.sections?.[props.step]?.label
          ? { ...prevStep, isValid: true }
          : prevStep
      )
    );
  }, []);

  return (
    <CurriculumPreviewPageView
      {...props}
      onSave={props.onSave}
      recordDetails={recordDetails}
    />
  );
};
